<template>
    <div class="page_content pg_upload_history">

        <div class="row page-heading">
            <div class="col-8 input module_heading">
                <span class="module_icon fas fa-cloud-upload-alt"></span>
                <span class="module_type_name">Background Task History</span>
            </div>
            <div class="col-4 submit btn-container text-right">
                <template v-if="isViewYourUploadHistory">
                    <button type="button" class="btn btn-primary" @click.prevent="viewUploadHistory" aria-label="view institution uploads history">view institution tasks history</button>
                </template>
                <template v-else>
                    <button type="button" class="btn btn-primary" @click.prevent="viewUploadHistory" aria-label="view your uploads history">view your tasks history</button>
                </template>
            </div>
        </div>

        <div class="folder-management-section" v-if="isDataSetupFromServer">
            <div class="page_subheading">
              <div class="toolbar-right ui-list-toolbar">
                <select v-model="perPage" aria-label="page size" class="page_size">
                  <option v-for="option in pageOptions" v-bind:value="option">
                    {{ option }}
                  </option>
                </select>
                <div class="btn_container pagination_sty3">
                  <b-pagination
                    align="center"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    :limit="1"
                    :hide-goto-end-buttons="true"
                    :label-prev="$t('previousPage')"
                    :label-next="$t('nextPage')">
                    <template #prev-text>
                      <span class="ic2_arr_pre3" aria-hidden="true"></span>
                    </template>
                    <template #next-text>
                      <span class="ic2_arr_next3" aria-hidden="true"></span>
                    </template>
                  </b-pagination>
                </div>
              </div>
            </div>

            <b-container fluid>
                <b-row class="data_tbl_container">

                	<template v-if="items.length === 0">
                        <span class="no_result">No Upload History Found</span>
                    </template>

                    <b-table bordered :isRowHeader="true" :head-variant="'light'" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" class="data_tbl tbl_upload_history">
                        <template slot="title" slot-scope="row">
                            <b-link :to="{name: 'taskMonitor', params: {taskId: row.item.id}}" class="task_name">{{row.value}}</b-link>
                        </template>
                    </b-table>

                </b-row>
            </b-container>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { DateTime } from 'luxon'

  export default {
    name: 'upload-history',
    data: () => {
      return {
        items: [],
        fields: [],
        totalRows: 0,
        currentPage: 1,
        perPage: 250,
        pageOptions: [ 250, 500, 750 ],
        isDataSetupFromServer: false,
        isViewYourUploadHistory: true,
        columnHeaders: [
          {key: 'title', label: 'Task Name', thClass: 'col_title', tdClass: 'col_title'},
          {key: 'email', label: 'Email', thClass: 'col_email', tdClass: 'col_email'},
          {key: 'outcome', label: 'Outcome', thClass: 'col_outcome', tdClass: 'col_outcome'},
          {key: 'percentage', label: '%', thClass: 'col_percentage', tdClass: 'col_percentage'},
          {key: 'fraction', label: 'Fraction', thClass: 'col_fraction', tdClass: 'col_fraction'},
          {key: 'status', label: 'Status', thClass: 'col_status', tdClass: 'col_status'},
          {key: 'startTime', label: 'Start Time', thClass: 'col_date', tdClass: 'col_date'}
        ]
      }
    },

    mounted () {
      this.loadUploadHistory()
    },

    methods: {
      ...mapActions([
        'loadYourUploadHistory',
        'loadInstitutionUploadHistory'
      ]),

      viewUploadHistory () {
        this.isViewYourUploadHistory = !this.isViewYourUploadHistory
        this.loadUploadHistory()
      },

      loadUploadHistory () {
        this.$refs.loadingModal.show()
        setTimeout(() => {
          this.populateUploadHistoty()
        }, 500)
      },

      populateUploadHistoty () {
        this.items = []
        this.fields = []
        if (this.isViewYourUploadHistory) {
          this.columnHeaders.forEach((item) => {
            if (item.key !== 'email') {
              this.fields.push(item)
            }
          })
          this.loadYourUploadHistory().then(res => {
            this.setUpData(res)
          })
        } else {
          this.columnHeaders.forEach((item) => {
            this.fields.push(item)
          })
          this.loadInstitutionUploadHistory().then(res => {
            this.setUpData(res)
          })
        }
      },

      setUpData (items) {
        if (items && items.length > 0) {
          items.forEach((tmp) => {
            let item = this.copyAndConvertEntity(tmp)
            this.items.push(item)
          })
        }
        this.currentPage = 1
        this.totalRows = this.items.length
        this.isDataSetupFromServer = true
        this.$refs.loadingModal.hide()
      },

      copyAndConvertEntity (tmp) {
        var o = {}
        o.id = tmp.id
        o.userId = tmp.userId
        o.title = tmp.title
        o.percentage = tmp.percentage
        o.fraction = '' + tmp.currentTaskSize + '/' + tmp.totalTaskSize
        o.insight = tmp.insight
        o.outcome = tmp.outcome
        o.nextSteps = tmp.nextSteps
        o.startTime = this.changeMillisToDate(tmp.startTime)
        o.endTime = this.changeMillisToDate(tmp.endTime)
        o.email = tmp.email
        o.status = tmp.error ? '<span style="color: red;">Failure</span>' : 'Success'
        return o
      },

      changeMillisToDate (selected) {
        return DateTime.fromMillis(selected).toFormat('LLL dd, yyyy t')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/taskMonitor/components/UploadHistory.vue